import React from "react";
import {isViewVisible} from "../../../utils/ViewSettings";
import ClientDocumentsView from "./components/ClientDocumentsView";
import Rbac from "../../../utils/Rbac";
import t from "../../helpers/t";
import {Biscuit} from "../../../utils";

export const rbac = new Rbac({
    _rbac: {
        "admin": {
            write: true,
            editVisualInspection: true,
            deleteVisualInspection: true,
            setContingent: true,
            setLocation: true
        },
        "manager": {
            write: true,
            editVisualInspection: true,
            deleteVisualInspection: true,
            setContingent: true,
            setLocation: true
        },
        "manager-location": {
            write: false,
            editVisualInspection: false,
            deleteVisualInspection: false,
            setContingent: false,
            setLocation: false
        },
        "user": {
            write: false,
            editVisualInspection: false,
            deleteVisualInspection: false,
            setContingent: false,
            setLocation: false
        },
        "garage-staff": {
            write: false,
            editVisualInspection: true,
            deleteVisualInspection: false,
            setContingent: false,
            setLocation: false
        }
    }
});

export const ClientDocumentsPage  = props => {
    let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    let indexView = Biscuit.get('user.is_superuser')  === 'true' ? 'client_documents' : '';
    const language = Biscuit.get('user.lang').replace('-','_');
    return (
        <>
            {(_view === 'client_documents' || (_view === 'index' && indexView === 'client_documents')) &&
            <ClientDocumentsView
                name={t("client_documents")}
                dispatch={props.dispatch}
                params={props.params}
                returnPath={props.returnPath}
                rbac={rbac}
                isViewVisible={isViewVisible}
                t={t}
                Biscuit={Biscuit}
                language={language}
            />
            }
            </>
    );
}